import React from 'react';
import Select from 'react-select';
import { getTheme } from 'utils/SelectTheme';
import SelectStyles from '../SelectStyles';

const GeographyQuestion = ({ regions, regionOptions, highRegionOptions, emergingRegionOptions, onRegionChange }) => (
  <div className="questions-grid">
    <label>
      <p>
        Where is your <span className="underlined">highest concentration</span> of users?
      </p>
      <Select
        placeholder="Select your primary region"
        options={
          regionOptions.map((option) => ({
            value: option.value,
            label: option.label,
          })) || []
        }
        value={regionOptions.find((option) => option.value === regions.highest) || null}
        onChange={onRegionChange('highest')}
        theme={getTheme}
        menuPlacement="auto"
        styles={SelectStyles}
      />
    </label>
    <label>
      <p>
        Where do you have <span className="underlined">high concentrations</span> of users? <span className="optional-label">(optional)</span>
      </p>
      <Select
        isMulti
        placeholder="Select additional regions (optional)"
        options={
          highRegionOptions.map((option) => ({
            value: option.value,
            label: option.label,
          })) || []
        }
        value={regionOptions.filter((option) => regions.high.includes(option.value))}
        onChange={onRegionChange('high', { isMulti: true })}
        theme={getTheme}
        menuPlacement="auto"
        styles={SelectStyles}
      />
    </label>
    <label>
      <p>
        Where do you have <span className="underlined">emerging concentrations</span> of users?
      </p>
      <Select
        isMulti
        className="select"
        placeholder="Select emerging markets"
        options={
          emergingRegionOptions.map((option) => ({
            value: option.value,
            label: option.label,
          })) || []
        }
        value={regionOptions.filter((option) => regions.emerging.includes(option.value))}
        onChange={onRegionChange('emerging', { isMulti: true })}
        theme={getTheme}
        menuPlacement="auto"
        styles={SelectStyles}
      />
    </label>
  </div>
);

export default GeographyQuestion;
